import * as angular from 'angular';
import { ComponentDefinition } from '../../models';

class LaunchCalculationButtonController implements angular.IComponentController {
    isLoading: boolean;

    // Types to be determined
    readonly initialRange;
    readonly selectedGroup;
    
    static $inject = [];

}

export const wtLaunchCalculationButton: ComponentDefinition = {
    componentId: 'wtLaunchCalculationButton',
    controller: LaunchCalculationButtonController,
    controllerAs: 'vm',
    template: require('./launchCalculationButton.component.html'),
    bindings: {
        initialRange: '<',
        selectedGroup: '<'
    }
};